import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibrariesService } from './libraries-service';
import { Library } from '../../types/library';
import { BehaviorSubject, finalize, switchMap, tap } from 'rxjs';
import { BrowsePaginatorComponent } from '../../features/browse-index/components/browse-paginator/browse-paginator.component';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';
import { PaginationState } from '../../features/browse-index/models';
import { LibrariesCard } from '../../shared/libraries-card/libraries-card';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-libraries',
  standalone: true,
  imports: [CommonModule, BrowsePaginatorComponent, BreadCrump, LibrariesCard, TranslateModule, FooterComponent],
  templateUrl: './libraries.html',
  styleUrl: './libraries.scss',
})
export class Libraries implements OnInit {
  private librariesService = inject(LibrariesService);

  private page$ = new BehaviorSubject<number>(1);
  private pageSize = 9;

  libraries: Library[] = [];
  loading = signal<boolean>(false)
  pagination: PaginationState = {
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0
  };

  ngOnInit(): void {
    this.page$.pipe(
      tap(() => this.loading.set(true)),
      switchMap(page => this.librariesService.getLibraries(page, this.pageSize))
    ).subscribe((res) => {
      this.libraries = res.result || [];
      this.pagination = {
        currentPage: this.page$.value,
        pageSize: this.pageSize,
        totalCount: res.totalElements,
        totalPages: Math.ceil(res.totalElements / this.pageSize) || 0
      };
      this.loading.set(false);
    })
  }

  onPageChange(page: number): void {
    this.page$.next(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}